var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.00083 3.41129C6.44799 3.41493 5.91884 3.63617 5.52791 4.02709C5.13699 4.41801 4.91576 4.94717 4.91211 5.5C4.91211 6.64323 5.8576 7.58872 7.00083 7.58872C8.14336 7.58872 9.08955 6.64323 9.08955 5.5C9.08955 4.35747 8.14336 3.41129 7.00083 3.41129Z",
    fill: "#818094"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.99999 0.626328C1.6856 0.626328 0.0884225 5.23334 0.0738014 5.27999L0 5.5L0.0731052 5.72002C0.0884225 5.76666 1.6856 10.3737 6.99999 10.3737C12.3144 10.3737 13.9116 5.76666 13.9262 5.72002L14 5.5L13.9269 5.27999C13.9116 5.23334 12.3144 0.626328 6.99999 0.626328ZM6.99999 8.9812C3.27441 8.9812 1.83111 6.30346 1.4816 5.5C1.8325 4.69376 3.2765 2.01881 6.99999 2.01881C10.7256 2.01881 12.1689 4.69654 12.5184 5.5C12.1675 6.30625 10.7235 8.9812 6.99999 8.9812Z",
    fill: "#818094"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.79ef5728b7015ec6baea461c91e02faa.svg";
export { ForwardRef as ReactComponent };